module.exports = __webpack_public_path__ + "media/images/icons/youtube-cd8d4218e12a1469844aa34d7974a2fa.png";